import { buildDateRangeFilterGroup, MOVEMENT_TYPE_OPTIONS, ORIGIN_CHANNEL_OPTIONS } from './filterSchemas.constants'

export const extractPointsFilterSchema = [
  {
    key: 'transaction-type-category',
    title: 'Detalhes da movimentação',
    filters: [
      {
        key: 'movementType',
        type: 'select',
        options: MOVEMENT_TYPE_OPTIONS
      },
      {
        key: 'origin.channel',
        type: 'select',
        options: ORIGIN_CHANNEL_OPTIONS
      }
    ]
  },
  buildDateRangeFilterGroup('eventDate', 'Data da movimentação', 'Data de ativação'),
  buildDateRangeFilterGroup('createdAt', 'Criação no fidelidade', 'Criado em'),
  buildDateRangeFilterGroup('expirationDate', 'Data da validade', 'Data de validade')
]
